import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import axios from '../tokenInterceptor';
import Slider from "react-slick";
import Loader from "react-loader-spinner";
import PlaySongs from "./PlaySongs";

function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
        <div
            className={"slick-next"}
            style={{
                ...style,
                top: "40%",
                display: "block",
                width: "20px",
                height: "20px",
            }}
            onClick={onClick}
        >
            <i className="fa fa-angle-right fa-2x" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
        <div
            className={"slick-prev"}
            style={{
                ...style,
                top: "40%",
                display: "block",
                width: "20px",
                height: "20px",
            }}
            onClick={onClick}
        >
            <i className="fa fa-angle-left fa-2x" />
        </div>
    );
}

class New extends Component {
    constructor(props) {
        super(props);
        this.state={
            topNewTracks:[],
            topAlbumsList:[],
            topPlaylistList:[],
            loader:true,
            popularMusicList:{
                "label_0_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                },
                "label_1_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                },
                "label_2_desc":{
                    "itemLabel":"",
                    "image":{
                        "uri": "",
                        "width": 250,
                        "height": 250,
                    }
                }
            },
            selectedMusic:{
                "title":"",
                "artist":""
            }
        }
    }

    componentWillMount=()=>{
        this.checkTokenExpire();
    }

    getMostPopularList =()=>{
        axios.get("/getNew").then((res)=>{
            if(res.data.status == 200) {
                this.setState({popularMusicList:res.data.data.itemDescriptions, loader:false});  
                this.getTopTracksList(); 
            } else {
                this.setState({popularMusicList:{}});
            }
        })
    }

    getTopTracksList =()=>{
        axios.get("/getNewTracks").then((res)=>{
            if(res.data.status == 200) {
                this.getTopAlbumsList();
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topSongsContents =[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                topSongsContents.push(data);
                };
                this.setState({topNewTracks:topSongsContents});    
            } else {
                this.setState({topNewTracks:[]});
            }
        })
    }

    getTopAlbumsList =()=>{
        axios.get("/getNewAlbums").then((res)=>{
            if(res.data.status == 200) {
                this.getTopPlaylistList();
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topAlbumContents =[]
                for(let i=0; i<num; i++) {
                let key = "album_"+i+"_desc";
                let data = td[key];
                topAlbumContents.push(data);
                };
                this.setState({topAlbumsList:topAlbumContents});    
            } else {
                this.setState({topAlbumsList:[]});
            }
        })
    }

    getTopPlaylistList =()=>{
        axios.get("/getNewPlaylists").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topPlaylistContents =[]
                for(let i=0; i<num; i++) {
                let key = "playlist_"+i+"_desc";
                let data = td[key];
                topPlaylistContents.push(data);
                };
                this.setState({topPlaylistList:topPlaylistContents});    
            } else {
                this.setState({topPlaylistList:[]});
            }
        })
    }

    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.album.name;
        selectedMusic.artist = data.artist.name;
        selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getMostPopularList();
            } else {
                console.log("unable t generate token");
            }
        });
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            this.getMostPopularList();
        } else {
            this.generateNewAccessToken();
        }
    }

    render() {
        const settings = {
            infinite: true,
            speed: 700,
            slidesToShow: 4,
            dots: false,
            slidesToScroll: 4,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        <div className="top-songs">
                            <h3 className="heading">{this.state.popularMusicList.label_0_desc.itemLabel}</h3>
                            <hr/>
                            <ul>
                                {this.state.topNewTracks.map((data, index)=>{
                                    return <li key={index} className="song-title">
                                        <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                        <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                        <div className="top-albums">
                            <h3 className="heading">{this.state.popularMusicList.label_1_desc.itemLabel}</h3>
                            <hr/>
                            <Slider {...settings}>
                                {
                                    this.state.topAlbumsList.map((data, index)=>{
                                    return<div className="p-2" key={index}>
                                            <img src={data.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>
                                        </div>
                                    })
                                }
                            </Slider>
                        </div>
                        <div className="top-playlist">
                            <h3 className="heading">{this.state.popularMusicList.label_2_desc.itemLabel}</h3>
                            <hr/>
                            <Slider {...settings}>
                                {
                                    this.state.topPlaylistList.map((data, index)=>{
                                    return<div className="p-2" key={index}>
                                            <img src={data.image.uri} alt="connect-img" className="img-fluid rounded slider_img" style={{"width":"150px", "height":"150px"}}/>
                                            
                                        </div>
                                    })
                                }
                            </Slider>
                        </div>
                        <PlaySongs
                            music={this.state.selectedMusic}
                        />
                    </div>
                </div>
            </>
            
        )
    }
}

export default New;
